/**
 *    @author:
 *    @since:
 *
 */

import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { AboutChild, Eligibility, InputData } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { Setup3Validation } from './setup_3.validator';
import { ItemList } from '../_common/constant/item-list';
import { ProgressService } from 'src/refresh/service/progress-service';
import { Confirm } from 'src/refresh/service/constant';
import { ViewportScroller } from '@angular/common';

@Component({ 
      selector: 'setup_3',
      templateUrl: './setup_3.component.html',
      styleUrls: ['./setup_3.component.less']
})
export class Setup3Component extends FormBaseComponent implements OnInit {

      public error_emptyIsBornThroughSurrogacy : string;
      public error_emptyIsCustodyOtherThanParent : string;
      public error_emptyIsOtherCertifyingBirth : string;
      public error_invalidOtherFirstName : string;
      public error_invalidOtherLastName : string;
      public error_invalidOtherSingleName : string;
      public expandSingleNameAccordion : boolean = false;

      public  isBornThroughSurrogacy:boolean;
      public  isCustodyOtherThanParent:boolean;

      orgContactPath = Path.ORGContactInformation;
      eligibility: Eligibility;
      aboutChild: AboutChild;

      constructor( protected router: Router ,
                   public timerService:TimerService,
                   protected progress:ProgressService,
                   public elRef:ElementRef,
                   public data:InputData,
                   public items:ItemList,
                   public viewportScroller: ViewportScroller ) {

            super(router,timerService);  
            super.setNextPage(Path.Setup4,Path.Setup2);
            super.setValidator(new Setup3Validation(this,Progress.Eligibility));

            this.eligibility = data.eligibility;
            this.aboutChild  = data.aboutChild;
            this.isCustodyOtherThanParent = this.eligibility.isCustodyOtherThanParent == Confirm.YES;
    
            InputData.currentPageIdx = 5;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      ngOnInit() {
      	super.forwardNext(this.data.eligibility.listedParentCount);
      }
      
      onCustodyOtherThanParentChange(){

            //if(this.eligibility.isCustodyOtherThanParent == "N"){
                  this.eligibility.isOtherCertifyingBirth = "";
            //}
            ////console.log("this.eligibility.isOtherCertifyingBirth","["+this.eligibility.isOtherCertifyingBirth+"]")
      }

      onCheckboxClick(){
            if(this.eligibility.isOtherSingleName == 'Y'){
                  this.expandSingleNameAccordion = true;
                  this.eligibility.otherLastName = "";
                  this.eligibility.otherFirstName = "";
                  this.error_invalidOtherFirstName = null;
                  this.error_invalidOtherLastName = null;
            }else{
                  this.expandSingleNameAccordion = false;
                  this.eligibility.otherSingleName = "";
                  this.error_invalidOtherSingleName = null;
            }
      }

     
      /**
      displayOnlyCancelBtnAsPrimary() {
            if ( this.eligibility.isOtherCertifyingBirth === "N" || 
                  ( this.eligibility.isOtherCertifyingBirth === "Y" && 
                  this.eligibility.isUnableToCertify == "Y")) {
                  return true;
            }

            return false;
      }

      displayCancelAsSecondaryBtn() {
            if (  this.eligibility.isBornThroughSurrogacy === "Y" ||
                  this.eligibility.isCustodyOtherThanParent === "Y") {
                  return true;
            }

            return false;
      } */
       

      displayCriticalBoxYes() {
            return (this.eligibility.isUnableToCertify == 'Y' && this.eligibility.isOtherCertifyingBirth == 'Y');
      }

      public onCancelApplication() {
             super.cancelApplication(this.data);
      }

      public onNextClick() : boolean {
             this.otherNameClear();
             this.productRemove();
             return super.onNextClick();
      }

      public onPreviousClick() {
             //this.otherNameClear();
             this.productRemove();
             super.onPreviousClick();
      }

      private otherNameClear() {
              if ( this.eligibility.isCustodyOtherThanParent != Confirm.YES ) {      
                   this.eligibility.otherFirstName = "";
                   this.eligibility.otherLastName = "";
                   this.eligibility.isOtherSingleName = "";
                   this.eligibility.otherSingleName = "";
              }
      }
      
      private productRemove() {

             if ( this.isCustodyOtherThanParent == (this.eligibility.isCustodyOtherThanParent == Confirm.YES) ) return;
             this.progress.adjustBundles(this.data);
     }

}